import React from 'react';
import PropTypes from 'prop-types';
import { ModalBody } from 'reactstrap';
import ScrollLock from 'react-scrolllock';

/** LockedModalBody
 * Use this component in place of a reactstrap ModalBody
 * in order to prevent scrolling on the <body> when a drawer
 * or modal is open.
 */
const LockedModalBody = props => (
  <ScrollLock>
    <ModalBody {...props}>
      {props.children}
    </ModalBody>
  </ScrollLock>
);

LockedModalBody.defaultProps = {
  children: null,
};

LockedModalBody.propTypes = {
  children: PropTypes.node,
};

export default LockedModalBody;



// WEBPACK FOOTER //
// ./src/components/Drawer/LockedModalBody/LockedModalBody.jsx